import React from 'react'
import ejemploPdf from '../../assets/files/Concurso/Listado Provisional Concurso DEPGFMLUZ 2026.pdf'
import { SecurePDFViewer } from '../../components/SecurePDFViewer'

const ConcursoListadoProvViewer = () => {
  return (
    <SecurePDFViewer pdfUrl={ejemploPdf} />
  )
}

export { ConcursoListadoProvViewer }